// src/components/NavigationHeader.js
import React from "react";
import { AppBar, Toolbar, Typography, IconButton, Box } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import { useTheme } from "@mui/material/styles";

const NavigationHeader = ({ onMenuClick, onTitleClick, onSearchClick, user }) => {
  const theme = useTheme();
  const backgroundImage =
    theme.palette.mode === "dark"
      ? "url('/assets/dogwood-texture-dark.png')"
      : "url('/assets/dogwood-texture.png')";
  // Get header text color from the theme.
  const headerTextColor = theme.palette.header?.text || theme.palette.text.primary;

  return (
    <AppBar
      position="static"
      sx={{
        borderRadius: 0,
        backgroundColor: "#AFE1AF", // You can also move this to theme if needed.
        backgroundImage,
        backgroundRepeat: "repeat",
        backgroundSize: "200px",
      }}
    >
      <Toolbar
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          minHeight: "70px",
        }}
      >
        {/* Left: Hamburger Icon */}
        <Box sx={{ width: 48, display: "flex", justifyContent: "center" }}>
          <IconButton onClick={onMenuClick} sx={{ color: headerTextColor }}>
            <MenuIcon />
          </IconButton>
        </Box>

        {/* Center: Title */}
        <Box sx={{ flexGrow: 1, textAlign: "center" }}>
          <Typography
            variant="h6"
            onClick={onTitleClick}
            sx={{
              fontFamily: "'Pacifico', cursive",
              fontWeight: "bold",
              fontSize: "1.8rem",
              lineHeight: 1.2,
              cursor: "pointer",
              color: headerTextColor,
            }}
          >
            Sunday Low Round
          </Typography>
        </Box>

        {/* Right: Search Icon */}
        <Box sx={{ width: 48, display: "flex", justifyContent: "center" }}>
          {user && (
            <IconButton onClick={onSearchClick} sx={{ color: headerTextColor }}>
              <SearchIcon fontSize="small" />
            </IconButton>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default NavigationHeader;